import cx from "classnames";
import React from "react";
import styles from "components/common/Price/Price.module.css";
import { PriceDiscountSelector } from "components/common/Price/PriceDiscountSelector";
import { DiscountOptionsFromSubscription } from "components/common/Price/utils";
import { SUBSCRIPTION_NAME_LOWER } from "constants/site";
import { formatUSD } from "helpers/strings";

export const Price = ({
  price,
  discountOptions,
  discountOnChange,
  tokensText,
}: {
  price: number | null | undefined;
  discountOptions: DiscountOptionsFromSubscription;
  discountOnChange: (value: string) => void;
  tokensText?: string | null;
}) => {
  return (
    <div className={styles.priceData}>
      {discountOptions.discountOptions && (
        <PriceDiscountSelector discountOptions={discountOptions} onChange={discountOnChange} />
      )}
      {price && (
        <div className={cx(discountOptions.isFreeOrDiscounted && "line-through")}>
          {formatUSD(price)}
        </div>
      )}
      {!price && !discountOptions.isFree && !tokensText && <div>FREE</div>}
      {!price && !discountOptions.isFree && tokensText}
      {discountOptions.isFree && (
        <>
          <div className="text-zur-orange-100">FREE</div>
          <div className="text-sm mt-2">
            This product is included with your {SUBSCRIPTION_NAME_LOWER}
          </div>
        </>
      )}
      {discountOptions.hasNewPrice && discountOptions.discountedPrice && (
        <>
          <div className="text-zur-orange-100">{formatUSD(discountOptions.discountedPrice)}</div>
          <div className="text-sm mt-2">
            This product is discounted with your {SUBSCRIPTION_NAME_LOWER}
          </div>
        </>
      )}
      {!!discountOptions.usageLimit && (
        <div className="text-xs mt-2 text-muted">
          You have redeemed {discountOptions.usageCount} of {discountOptions.usageLimit} available
          instances of this perk
        </div>
      )}
      {!!discountOptions.ceLimit && (
        <div className="text-xs mt-2 text-muted">
          You have redeemed {discountOptions.ceCount} of {discountOptions.ceLimit} available CEs
        </div>
      )}
    </div>
  );
};
